module.exports = __webpack_public_path__ + "static/media/startHeroPoster.406a9f6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/startHeroPoster.png
// module id = 538
// module chunks = 0